// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2K7NS","buttons":"PendingPaymentAlert_buttons__93HJ5"};